import ApiService from "../api";

export default class AjusteComissaoService extends ApiService {

    constructor() {
        super("/api/ajustes-comissao");
    }

    listar(filtros) {
        const params = new URLSearchParams();
        params.append('mes', filtros.mes);
        params.append('ano', filtros.ano);
        return this.get(`?${params.toString()}`);
    }

    buscar(id) {
        return this.get(`/${id}`);
    }

    solicitar(data) {
        return this.post("/solicitar", data);
    }

    ajustarRetorno(data) {
        return this.post(`/ajustar-retornos`, data);
    }

    aprovar(id) {
        return this.put(`/${id}/aprovar`);
    }

    rejeitar(id) {
        return this.put(`/${id}/reprovar`);
    }

}